export default "__VITE_ASSET__135521b7__"